import { createReducer, ISuccessfulAction } from '../ReduxDecorators';
import modalActions from '@ane/legacy/lib/services/ModalActions';

export interface IModalReducerState {
  modals: JSX.Element[];
}
const defaultState: IModalReducerState = { modals: [] };

export class ModalReducer {
  public createModal(state: IModalReducerState, action: ISuccessfulAction<JSX.Element>) {
    return {
      ...state,
      modals: [...state.modals, action.payload],
    };
  }

  public hideModal(state: IModalReducerState, action: ISuccessfulAction<JSX.Element>) {
    return {
      ...state,
      modals: state.modals.filter((m) => m !== action.payload),
    };
  }
}

export default createReducer(modalActions, new ModalReducer(), defaultState);
